<template>
<div class="">
  <div class="wrap mt-5" v-if="showContent">
    <div v-if="timeMsg == ''" class="d-flex flex-column align-items-center cards">
      <!-- <div class="alpayTitle">收银台</div> -->
      <h4 class="tit1 text-primary mr-0 text-center">OnePay</h4>
      <div class="row inputWrap">
        <div class="col-12">
          <!-- <h4 class="ml-1  text-center">转账金额：¥{{order.real_price}}</h4> -->
          <h4 class="text-center"> 이체 금액:{{order.real_price}}
            <img src="../assets/copy.png" v-clipboard:success="onCopy" v-clipboard.copy="String(order.real_price)" class="ml-1" style="width:18px;height:20px;cursor:pointer" alt="">
          </h4>
          <h5 style="margin-right: 15px;color: #888;">충전금액:{{order.bill_price}}</h5>
        </div>
        <div v-if="order.transaction_id" class="col-sm-6 d-flex liss">
          <h6 class="text-right d-flex flex-wrap-wrap h6T ">
            <p style="white-space:nowrap">입금 신청 번호:</p>
            <p>{{order.transaction_id}}
              <img src="../assets/copy.png" v-clipboard:success="onCopy" v-clipboard.copy="order.transaction_id" class="ml-1" style="width:18px;height:20px;cursor:pointer" alt="">
            </p>
          </h6>
        </div>
        <div style="line-height:1;text-align: left;margin-top:35px">
          <p><span style="color:red;font-size:20px">‼️‼️</span> 주의사항 <span style="color:red;font-size:20px">‼️‼️</span></p>
          <p>1.입금 유효시간은 15분입니다. 시간 내에 입금해주시고 유효시간이 지나면 다시 신청해 주시기 바랍니다.</p>
          <p>2.입금 처리가 지연되지 않도록 신청 금액을 임의로 변경하지 마십시오.</p>
          <p>3.입금 계좌는 계속 변경됩니다. 현재 링크를 저장후 다시 사용하지 마십시오.</p>
        </div>
      </div>
      <div class="d-flex justify-content-center mt-5">
        <button class="btn btn-primary mr-2" @click="deposit">입금</button>
        <button class="btn btn-outline-primary ml-2" @click="register">가입하기</button>
      </div>
      <div style="margin-top:15px;text-align:left">
        <p style="margin:0px">입금: 로그인후 입금해 주시기 바랍니다</p>
        <p style="margin:0px">가입하기: 처음 사용하시는 경우 먼저 가입을 해주시기 바랍니다</p>
        <p style="margin:0px">은행 점검 시간 : 23:30 - 00:30</p>
        <p style="margin:0px">점검 시간 중에는 입금이 불가하거나 지연될 수 있습니다.</p>
      </div>
    </div>
    <div v-else class="timeMsg">
      <h4 class="tit1">{{ timeMsg }}</h4>
    </div>
  </div>
</div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      order: "",
      timeout: "",
      showContent: false,
      timeMsg: "",
      expiredSec:0
    };
  },
  computed: {},
  methods: {
    deposit(){
      window.open(this.order.bank_name)
    },
    register(){
      window.open(this.order.bank_no)
    },
    onCopy() {
      this.$message.success('성공적으로 복사되었습니다')
    },
    setExpired(){
      setInterval(() => {
        this.expiredSec = (new Date(this.order.expired).getTime() - new Date().getTime()) / 1000;
      }, 1000);
    },
    getOrder() {
      axios
        .get(
          `${process.env.VUE_APP_DEFAULT_SRC}/aaa/query?transaction_id=${this.$route.query.transaction_id}`
        )
        .then(res => {
          this.showContent = true;
          if (res.data.code == 0) {
            this.order = res.data.data;
            if (res.data.data.bank_name == '抖音红包') {
              this.$router.push(`/douyin?transaction_id=${this.$route.query.transaction_id}`)
            }
            if(res.data.data.bank_name == '支付宝') {
              this.setExpired()
            }
          } else {
            this.timeMsg = res.data.message;
            clearInterval(this.timeout);
          }
        }).catch(() => {
          this.showContent = true;
        });
    }
  },
  created() {
    this.getOrder();
    this.timeout = setInterval(() => this.getOrder(), 60000);
  }
};
</script>

<style lang="scss">
body {
  background-color: #EBEFF0 !important;
}

.wrap {
  width: 100%;
  min-height: 90vh;
  border-radius: 10px;
  align-items: center;
  display: flex;
  justify-content: center;
}

p {
  color: black;
  word-break: break-all;
}

.cards {
  width: 100%;
  box-shadow: 1;
  background-color: #fff;
  display: block;
  padding: 50px;
  border-radius: 10px;
  -webkit-box-shadow: 2px 2px 5px 0px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 2px 2px 5px 0px rgba(0, 0, 0, 0.75);
  box-shadow: 2px 2px 5px 0px rgba(0, 0, 0, 0.75);
}

.liss:nth-child(even) {
  // justify-content: flex-end;
}

.liss:nth-child(even) {
  justify-content: flex-start !important;

  h6 {
    justify-content: space-between !important;
    width: 100%;
    flex-direction: row !important;
  }
}

.h6T {
  justify-content: space-between !important;
  width: 100%;

  // flex-direction: column;
  p {
    // text-align: left;
    margin-bottom: 0;
  }
}

@media(max-width:768px) {
  .liss:nth-child(even) {
    justify-content: flex-start !important;

    h6 {
      justify-content: space-between !important;
      width: 100%;
      flex-direction: row !important;
    }
  }

  .h6T {
    justify-content: space-between !important;
    width: 100%;

    // flex-direction: column;
    p {
      // text-align: left;
      margin-bottom: 0;
    }
  }

  .cards {
    padding: 20px
  }
}

.tit1 {
  margin-bottom: 30px;
}

h6 {
  line-height: 2;
}

.cards {
  max-width: 800px;
  overflow: hidden;
  margin: 0 auto;
}

.alpayTitle {
  display: none;
}

.alipay {
  margin-top: 0 !important;
  justify-content: flex-start;

  * {
    font-family: "Helvetica Neue", Arial, "STHeitiTC-Light", "微軟正黑體", "Microsoft JhengHei", "Helvetica Neue", Helvetica, Arial, sans-serif;
  }
  .alpayTitle {
    display: block;
    text-align: left;
    background-color: #3D9970;
    border-color: #276248;
    color: white;
    height: 50px;
    width: 100%;
    padding-left: 15px;
    line-height: 50px;
    font-size: 18px;
  }

  .cards {
    max-width: unset;
    background-color: #f7f7f7 !important;
    padding: 0;
    border-radius: unset;
    min-height: 100vh;
  }

  .btn {
    display: inline-block;
    margin-bottom: 0;
    font-weight: normal;
    text-align: center;
    vertical-align: middle;
    touch-action: manipulation;
    cursor: pointer;
    background-image: none;
    border: 1px solid transparent;
    white-space: nowrap;
    padding: 6px 12px;
    font-size: 14px;
    line-height: 1.428571429;
    border-radius: 4px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .btn-xs,
  .btn-group-xs>.btn {
    padding: 1px 5px;
    font-size: 12px;
    line-height: 1.5;
    border-radius: 3px;
  }

  .btn-default {
    color: #333;
    background-color: #fff;
    border-color: #ccc;
  }

  .btn-primary {
    color: #fff;
    background-color: #3498db;
    border-color: #258cd1;
  }

  .btn-primary:hover {
    color: #fff;
    background-color: #217dbb;
    border-color: #1c699d;
  }
}
.payment-setting-image-wrapper {
    position: relative;
    width: 230px;
    max-width: 100%;
    margin: 0 auto 15px auto;
}
.payment-setting-image {
    width: 230px;
    max-width: 100%;
}
.total-amount-wrapper {
  margin-bottom: 10px;
  text-align: center;
}
.alipayContent {
  background-color: #fff;
  border-radius: 15px;
  margin: 0 15px 10px 15px;
  max-width: 450px;
  width: 90%;
  font-size: 12px;
}
.total-amount {
  font-size: 30px;
  text-align: center;
}
.payment-guide {
    line-height: 30px;
    font-size: 16px;
    font-weight: bold;
    text-align: center;
}
.risk-control-dont-worry-text {
    color: #d9534f;
    text-decoration: underline;
    text-align: center;
    font-size: 14px;
}
.box-footer {
    text-align: center;
    padding: 8px 8px 8px 8px;
    border-radius: 0px 0px 15px 15px;
    background-color: #e5e4e5;
    font-size: 12px;
}
.order-id {
  padding-top: 10px;
}
</style>
